import { Container } from 'inversify';
import UserService from '../../services/user.service';

export const container = new Container();

container
  .bind<UserService>(UserService)
  .toSelf()
  .inSingletonScope();
